import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FaExclamationTriangle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import './VerificationRequiredModal.css';

interface VerificationRequiredModalProps {
  show: boolean;
  onHide: () => void;
  title?: string;
  message?: string;
}

const VerificationRequiredModal: React.FC<VerificationRequiredModalProps> = ({
  show,
  onHide,
  title,
  message,
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop={true}
      keyboard={true}
    >
      <Modal.Header closeButton className="border-0 align-items-start" />
      <Modal.Body className="text-center pb-4 pt-0 px-4">
        <div
          className="d-flex align-items-center justify-content-center mx-auto mb-3"
          style={{
            width: 70,
            height: 70,
            borderRadius: "50%",
            background: "rgba(217, 119, 6, 0.1)",
            fontSize: "32px",
            color: "#d97706",
          }}
        >
          <FaExclamationTriangle />
        </div>
        <h4 className="fw-bold mb-2" style={{ color: "#d97706" }}>
          {title || "Verification Required"}
        </h4>
        <p className="text-muted mb-4 px-2" style={{ fontSize: "14px", lineHeight: "1.5" }}>
          {message || "Please verify your domain to send messages, manage connections, view resumes, or perform professional candidate actions."}
        </p>
        <div className="d-flex justify-content-center gap-3">
          <Button
            variant="outline-secondary"
            onClick={onHide}
            className="rounded-3 px-4 btn-close-custom"
            style={{ width: "120px" , height:'40px',fontWeight:500}}                
          >
            Close
          </Button>
          <Button
            variant="warning"
            onClick={() => {
              onHide();
              navigate("/business-verification");
            }}
            className="rounded-3 px-4 fw-semibold text-white"
            style={{ background: "#d97706", borderColor: "#d97706", width: "160px",height:'40px'}}
          >
            Verify Now
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VerificationRequiredModal;
